const SALES_ASSIST_TRACKING_EVENTS = {
  salesAssist: {
    accountInfo: {
      accountExists: true,
      emailFieldFilled: true,
      error: true,
      essentialsFeaturesModal: true,
      firstNameFieldFilled: true,
      lastNameFieldFilled: true,
      nextClicked: true,
      passwordFieldFilled: true,
      phoneFieldFilled: true,
      podiumEssentialsClick: true,
      visited: true,
    },
    accountExists: {
      nextClicked: true,
      visited: true,
    },
    businessInfo: {
      addressFieldFilled: true,
      addressOptionalFieldFilled: true,
      cityFieldFilled: true,
      countryFieldFilled: true,
      enterManualClick: true,
      fieldError: true,
      gmbClick: true,
      googleAddressClicked: true,
      nameFieldFilled: true,
      nextClicked: true,
      phoneFieldFilled: true,
      stateFieldFilled: true,
      visited: true,
      zipFieldFilled: true,
    },
    createTrial: {
      error: true,
      success: true,
    },
    selectedBundle: {
      plan: true,
    },
    suggestedEmail: {
      clicked: true,
      suggested: true,
    },
  },
};

export default SALES_ASSIST_TRACKING_EVENTS;
